import React from "react";

const GlobalContext = React.createContext();

export class GlobalProvider extends React.Component {
  constructor(props) {
    super(props);
    // Verifica se existe dados salvos no localStorage ao inicializar
    const savedGlobalValue = localStorage.getItem('globalContextValue');
    this.state = {
      globalValue: savedGlobalValue ? JSON.parse(savedGlobalValue) : null,
    };
  }

  setGlobalValue = (value) => {
    // Salva no state e também no localStorage para persistir entre recarregamentos
    this.setState({ globalValue: value }, () => {
      localStorage.setItem('globalContextValue', JSON.stringify(value));
    });
  };

  render() {
    return (
      <GlobalContext.Provider
        value={{
          globalValue: this.state.globalValue,
          setGlobalValue: this.setGlobalValue,
        }}
      >
        {this.props.children}
      </GlobalContext.Provider>
    );
  }
}

export default GlobalContext;